import { Box, Grid, Typography, Theme } from '@mui/material';
import { SubHeading } from '../investors/components';
import React from 'react';
import { Item, ItemDetails, Gridstyles } from './index';
import { Applicant } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { SxProps } from '@mui/system';
import {
  Relations,
  YesNoMaster,
  applicantStatusMasters,
  educationQualificationMasters,
  fatherOrSpouseSelectMasters,
  maritalStatusMasters,
  occupationDetailsMasters,
} from '../../utils/constant';
import { getOccupationType, getRelation } from '../../utils/utilityFunctions';

export const KeyValue = ({
  title,
  description,
  amount,
  sx = {},
}: {
  title: string | undefined;
  description?: string | number | boolean | null;
  amount?: number | null | undefined | string;
  sx?: SxProps<Theme>;
}): JSX.Element => {
  return (
    <Grid item xs={12} sm={6}>
      <Item sx={sx}>{title}</Item>
      <ItemDetails> {description ? description : '-'}</ItemDetails>
      {!!amount && amount !== 0 && <Item sx={{ pt: 0 }}> {amount}</Item>}
    </Grid>
  );
};

export default function ContributorDetails({
  applicants = [],
  modeOfHolding,
}: {
  applicants: Partial<Applicant>[];
  modeOfHolding: string;
}): JSX.Element {
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
                Applicant(s) Details
              </Typography>
              <Typography
                component="span"
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'text.secondary',
                }}>
                Mode of Holding:{' '}
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    letterSpacing: '0.4px',
                    ml: 0.5,
                    textTransform: 'capitalize',
                  }}>
                  {modeOfHolding === 'either or survivor' ? 'Joint' : modeOfHolding || 'Single'}
                </Typography>
              </Typography>
            </Grid>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Personal Details',
                'Second Applicant Personal Details',
                'Third Applicant Personal Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {title}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'Full Name'} description={applicant.name} />
                      <KeyValue title={'Gender'} description={applicant.gender} />
                      <KeyValue title={'First Name'} description={applicant.firstName} />
                      <KeyValue title={'Last Name'} description={applicant.lastName} />
                      <KeyValue title={'Mother Name'} description={applicant.motherName} />
                      <KeyValue
                        title={'Father/Spouse'}
                        description={fatherOrSpouseSelectMasters[applicant.fatherOrSpouse || '']}
                      />
                      <KeyValue
                        title={'Father/Spouse Name'}
                        description={applicant.fatherOrSpouseName}
                      />
                      <KeyValue
                        title={'Date Of Birth'}
                        description={formatShortDate(applicant.dateOfBirth)}
                      />
                      <KeyValue
                        title={'Marital Status'}
                        description={maritalStatusMasters[applicant.maritalStatus || '']}
                      />
                      <KeyValue
                        title={'Occupation Type'}
                        description={
                          getOccupationType(applicant.occupationDetails)
                            ? occupationDetailsMasters[applicant.occupationDetails || '']
                            : applicant.occupationDetails
                        }
                      />
                      <KeyValue title={'Provide Aadhaar'} description={applicant.aadhaarCheck} />
                      {applicant.aadhaarCheck === YesNoMaster.yes && (
                        <KeyValue
                          title={'Aadhaar Last 4 Digit'}
                          description={applicant.aadhaarNumber}
                        />
                      )}
                      <KeyValue
                        title={'Status'}
                        description={
                          applicant.status
                            ? applicantStatusMasters[applicant.status]
                            : applicant.status
                        }
                      />
                      <KeyValue
                        title={'Nationality of First Applicant'}
                        description={applicant.nationality}
                      />
                      <KeyValue title={'PAN'} description={applicant.panNo} />
                      {/* <KeyValue
                        title={'Status'}
                        description={
                          applicant.status
                            ? applicantStatusMasters[applicant.status]
                            : applicant.status
                        }
                      /> */}
                      {index !== 0 && (
                        <KeyValue
                          title={'RelationShip With First Applicant'}
                          description={
                            getRelation(applicant.relationShipWithFirstApplicant)
                              ? Relations[applicant.relationShipWithFirstApplicant || '']
                              : applicant.relationShipWithFirstApplicant
                          }
                        />
                      )}
                      <KeyValue title={'GST Number'} description={applicant.gstNumber} />
                      <KeyValue title={'GST State'} description={applicant.gstState} />
                    </Grid>
                  </Gridstyles>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    Applicant occupation and education details
                  </SubHeading>
                  <Box sx={{ width: '100%' }}>
                    <Gridstyles>
                      <Grid
                        item
                        container
                        pb={5}
                        rowSpacing={6}
                        columnSpacing={13}
                        direction="row"
                        justifyContent="space-between"
                        alignItems="flex-start">
                        <KeyValue
                          title={'Educational Qualification'}
                          description={
                            educationQualificationMasters[applicant.educationalQualification || '']
                          }
                        />
                        <KeyValue title={'Tax Assessee'} description={applicant.taxAssesseeCheck} />
                      </Grid>
                    </Gridstyles>
                  </Box>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
